import * as React from 'react';

import './styles.css';
import { ICustomSwiperNavigationRef, CustomSwiper } from '../../../../components/CustomSwiper';
import { CLUSTER_SWIPER_OPTIONS } from '../../../../constants/cluster';

interface IStandardCarouselProps {
  children: React.ReactElement[];
  navRef: ICustomSwiperNavigationRef;
}

export function ClusterCarousel({ children, navRef }: IStandardCarouselProps) {
  return (
    <CustomSwiper className="cluster-carousel" {...CLUSTER_SWIPER_OPTIONS} navRef={navRef}>
      {children}
    </CustomSwiper>
  );
}
